import http from "../http-common";

class OfferAcademicService {
  getAll() {
    return http.get("/OfertaAcademica");
  }
}

export default new OfferAcademicService();